import StripeForm from '@/components/StripeForm';
import {DialogContent, Grid2} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import type * as React from 'react';

export type Props = {
    open: boolean;
    handleClosePaymentModal: () => void;
    amount: number;
    description: string;
    membershipTypeId: string;
};

const PaymentModal = ({
    open,
    handleClosePaymentModal,
    amount,
    description,
    membershipTypeId,
}: Props): React.ReactElement => {
    return (
        <Dialog onClose={handleClosePaymentModal} open={open}>
            <DialogTitle>Payment Modal</DialogTitle>
            <DialogContent>
                <Grid2 container>
                    <Grid2 size={12}>
                        All fees must be paid in full by the due date for this activity. Any
                        registrations with outstanding fees after the due date will be cancelled.
                    </Grid2>
                    {description !== '' && (
                        <Grid2 size={12} sx={{mt: 2, whiteSpace: 'pre-wrap'}}>
                            Description: {description.replaceAll('\r', '\n')}
                        </Grid2>
                    )}
                    <Grid2 size={12} sx={{mt: 2, fontWeight: 600}}>
                        Cost: ${amount}
                    </Grid2>
                    <Grid2 size={12} sx={{my: 2}}>
                        <StripeForm
                            handleClose={handleClosePaymentModal}
                            membershipTypeId={membershipTypeId}
                        />
                    </Grid2>
                </Grid2>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentModal;
